import { render, staticRenderFns } from "./ArtistPromotionDialog.vue?vue&type=template&id=514c6e50&scoped=true"
import script from "./ArtistPromotionDialog.vue?vue&type=script&lang=js"
export * from "./ArtistPromotionDialog.vue?vue&type=script&lang=js"
import style0 from "./ArtistPromotionDialog.vue?vue&type=style&index=0&id=514c6e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c6e50",
  null
  
)

export default component.exports